import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AOS from "aos"
import "aos/dist/aos.css"
import NewsStrip from "../components/news-strip"
import MetroFaresPrimary from "../components/metro-fares-primary"

class ServiceP45Page extends Component {
  componentDidMount() {
    AOS.init()
    window.addEventListener("load", AOS.refresh)
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000)
  }

  componentDidUpdate() {
    AOS.refresh()
  }

  render() {
    return (
      <Layout>
        <SEO
          title="P45"
          description="View route information and buy your ticket for the P45 service operated by Tetley's Coaches."
        />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent">
            <div className="text-center">
              <h1 className="page-content-heading">P45 service</h1>
              <p>Bramham - Lady E Hastings T. Arch</p>
              <p>Lady E Hastings T. Arch - Bramham</p>
            </div>
          </div>

          <div className="body gutter page-content-parent">
            <div className="page-content">
              <div className="page-content__text">
                <h2>AM Route</h2>
                <p style={{ margin: '15px 0'}}>This service will pick up/set down at all regular bus stops along the following route:</p>
                <h3 style={{ margin: '10px 0'}}>AM route</h3>
                <iframe
                  title="P45 AM route map"
                  className="route-map"
                  src="https://www.google.com/maps/d/embed?mid=1fGBitWBLTkNuGcVbbeufbhYApIHb-s0&ehbc=2E312F"
                  width="100%"
                  height="480"
                ></iframe>
                <p>
                  <strong>Towards</strong> Lady Elizabeth Hasting's School
                </p>
                <p>
                  From Bowcliffe Road, Front Street, Clifford Road, Bramham Road, High Street,
Chapel Lane, Boston Road, St John's Road, Clifford Road, High Street, Grove Road,
Clifford Road, St John's Road, Boston Road, Chapel Lane, High Street, Willow Lane,
Clifford Moor Road, High Street, Bridge Road, Bridge Foot, The Village, Church
Causeway, Walton Road, Wighill Lane, Smiddy Hill, Main Street, School Lane,
Wetherby Road, Walton Road, Church Causeway, Dowkell Lane.
                </p>

                <h3 style={{ margin: '10px 0'}}>PM route</h3>
                <iframe
                  title="P53 PM route map"
                  className="route-map"
                  src="https://www.google.com/maps/d/embed?mid=12VjpcseT0y9q3s2CqwbBblzTmLFduyY&ehbc=2E312F"
                  width="100%"
                  height="480"
                ></iframe>
                <p>
                  <strong>From</strong> Lady Elizabeth Hastings School Thorpe Arch
                </p>
                <p>
                  From Dowkell Lane, The Village, Church Causeway, Walton Road, Wighill Lane,
Smiddy Hill, Main Street, School Lane, Wetherby Road, Walton Road, Church
Causeway, The Village, Bridge Foot, Bridge Road, High Street, Clifford Moor Road,
Primrose Lane, Church Street, St John’s Road, Clifford Road, High Street, Grove
Road, Clifford Road, St John’s Road, Boston Road, Chapel Lane, High Street,
Bramham Road, Clifford Road, Front Street, Bowcliffe Road
                </p>
              </div>
              <div className="page-content__text">
                <h2>Timetable</h2>
                <table className="timetable">
                  <thead>
                    <tr>
                      <th colSpan="3">Morning</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Bramham</td>
                      <td>DEP</td>
                      <td>0810</td>
                    </tr>
                    <tr>
                      <td>Grove Road at Grove Road</td>
                      <td>DEP</td>
                      <td>0825</td>
                    </tr>
                    <tr>
                      <td>Clifford Moor Road – Clifford</td>
                      <td>DEP</td>
                      <td>0830</td>
                    </tr>
                    <tr>
                      <td>Walton Corner</td>
                      <td>DEP</td>
                      <td>0837</td>
                    </tr>
                    <tr>
                      <td>Lady E Hastings</td>
                      <td>ARR</td>
                      <td>0840</td>
                    </tr>
                  </tbody>
                </table>

                <table className="timetable">
                  <thead>
                    <tr>
                      <th colSpan="3">Afternoon</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Lady E Hastings</td>
                      <td>DEP</td>
                      <td>1515</td>
                    </tr>
                    <tr>
                      <td>Walton Road at Grange Avenue</td>
                      <td>DEP</td>
                      <td>1525</td>
                    </tr>
                    <tr>
                      <td>Clifford Moor Road - Clifford</td>
                      <td>DEP</td>
                      <td>1530</td>
                    </tr>
                    <tr>
                      <td>Grove Road at Grove Road</td>
                      <td>DEP</td>
                      <td>1535</td>
                    </tr>
                    <tr>
                      <td>Bramham</td>
                      <td>ARR</td>
                      <td>1541</td>
                    </tr>
                  </tbody>
                </table>

                <MetroFaresPrimary />
              </div>
            </div>
          </div>
        </div>

        <NewsStrip />
      </Layout>
    )
  }
}

export default ServiceP45Page
